import { render, staticRenderFns } from "./crudDeposits.vue?vue&type=template&id=038c2a19&"
import script from "./crudDeposits.vue?vue&type=script&lang=js&"
export * from "./crudDeposits.vue?vue&type=script&lang=js&"
import style0 from "./crudDeposits.vue?vue&type=style&index=0&id=038c2a19&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports